import React from "react";
import { ParticipantContributionDataContainer } from "../../../containers";

const ParticipantContributionDataReports = (props) => {
  return <ParticipantContributionDataContainer {...props} />;
};

export default ParticipantContributionDataReports;
